module.exports = __webpack_public_path__ + "static/media/19b.eb70b314.jpg";